import { useEffect, useRef } from 'react';

export function useActiveItemScroll<T extends HTMLElement>(activeIndex: number) {
  const activeItemRef = useRef<T | null>(null);
  useEffect(() => {
    activeItemRef.current?.scrollIntoView({ block: 'nearest' });
  }, [activeIndex]);
  return activeItemRef;
}
